import axios from './Api';

export function GetExportStatus(cityHallId: string | number) {
  return axios.get<Partner.IExportPartner[]>('/adminpartners/export/status', { params: { cityHallId } });
}

export function GetExportCount(cityHallId: string | number) {
  return axios.get<Partner.IPartnerExportCount>('/adminpartners/export/count', { params: { cityHallId } });
}

export function CancelExport(id: string | number = '', cityHallId: string | number) {
  return axios.get<Axios.IResponseSuccess>(`/adminpartners/export/${id}/cancel`, { params: { cityHallId } });
}

export function GerExportFile(id: string | number = '', cityHallId: string | number) {
  return axios.get<Partner.IPartnerExportFile>(`/adminpartners/export/${id}/download`, {
    params: { cityHallId },
    responseType: 'blob'
  });
}

export function ExportPartner(cityHallId: string | number) {
  return axios.post<Partner.IExportPartner>('/adminpartners/export', null, { params: { cityHallId } });
}
